import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function SuccessStoriesPage() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('stories');

  // قصص نجاح (نماذج)
  const successStories = [
    {
      id: 1,
      title: 'أحمد وسارة',
      location: 'الرياض',
      date: 'رمضان 1445',
      story: 'تعرفنا على بعض من خلال وِداد، وكان التوافق واضحاً من أول محادثة. جمعتنا الاهتمامات المشتركة في القراءة والتطوع. بعد 3 أشهر من التعارف الجاد، تمت الخِطبة بحمد الله.',
      image: '💑'
    },
    {
      id: 2,
      title: 'محمد ونورة',
      location: 'جدة',
      date: 'شعبان 1445',
      story: 'كنت أبحث عن شريكة تشاركني اهتمامي بالتقنية، ووجدتها في وِداد. نورة مهندسة برمجيات مثلي، والآن نخطط لمشروعنا الخاص معاً بعد الزواج.',
      image: '💍'
    },
    {
      id: 3,
      title: 'خالد وريم',
      location: 'الدمام',
      date: 'جمادى الآخرة 1445',
      story: 'ما أعجبني في وِداد هو التركيز على التوافق الحقيقي. وجدت ريم التي تشاركني نفس القيم والطموحات. الحمد لله، تزوجنا الشهر الماضي.',
      image: '🎊'
    }
  ];

  // نصائح ومقالات
  const articles = [
    {
      id: 1,
      title: 'كيف تختار شريك حياتك؟',
      category: 'نصائح',
      icon: '💡',
      content: `
        <h4>١. حدد أولوياتك</h4>
        <p>قبل البحث، اكتب قائمة بالصفات الأساسية التي تبحث عنها. ركز على القيم والأخلاق أولاً.</p>
        
        <h4>٢. كن صادقاً في ملفك</h4>
        <p>الصدق أساس أي علاقة ناجحة. اكتب عن نفسك بصدق دون مبالغة.</p>
        
        <h4>٣. لا تستعجل</h4>
        <p>خذ وقتك في التعرف على الطرف الآخر. الزواج قرار مصيري يستحق التأني.</p>
        
        <h4>٤. أشرك أهلك</h4>
        <p>عندما تجد شخصاً مناسباً، أشرك أهلك في القرار. نصيحتهم قيّمة.</p>
      `
    },
    {
      id: 2,
      title: 'آداب التعارف الشرعي',
      category: 'شرعي',
      icon: '📖',
      content: `
        <h4>الاحترام المتبادل</h4>
        <p>تعامل مع الطرف الآخر باحترام وأدب، فهو ابن/ابنة أناس كرام.</p>
        
        <h4>الوضوح في النوايا</h4>
        <p>كن واضحاً أن هدفك الزواج الشرعي، لا التسلية أو إضاعة الوقت.</p>
        
        <h4>حدود المحادثة</h4>
        <p>التزم بالحديث الهادف المتعلق بالتعارف. تجنب المواضيع غير اللائقة.</p>
        
        <h4>إشراك الولي</h4>
        <p>بعد التوافق المبدئي، يجب إشراك ولي الأمر لإتمام الخطوات الشرعية.</p>
      `
    },
    {
      id: 3,
      title: 'علامات التوافق الحقيقي',
      category: 'نصائح',
      icon: '✨',
      content: `
        <h4>التوافق في القيم</h4>
        <p>هل تتفقون على الأمور الجوهرية في الحياة؟ الدين، تربية الأبناء، الأهداف؟</p>
        
        <h4>الراحة في الحديث</h4>
        <p>هل تشعر بالراحة عند الحديث معه/معها؟ هل يمكنك أن تكون على طبيعتك؟</p>
        
        <h4>التفاهم عند الاختلاف</h4>
        <p>كيف تتعاملون مع الاختلاف؟ هل يمكنكم النقاش بهدوء واحترام؟</p>
        
        <h4>الدعم المتبادل</h4>
        <p>هل يدعم كل منكما طموحات الآخر وأهدافه؟</p>
      `
    },
    {
      id: 4,
      title: 'أخطاء شائعة في البحث عن شريك',
      category: 'تحذيرات',
      icon: '⚠️',
      content: `
        <h4>التركيز على المظهر فقط</h4>
        <p>الجمال يزول، لكن الأخلاق والدين يبقيان. وازن في معاييرك.</p>
        
        <h4>تجاهل العلامات التحذيرية</h4>
        <p>إذا لاحظت سلوكاً مقلقاً، لا تتجاهله. استشر أهلك.</p>
        
        <h4>الاستعجال بسبب الضغط</h4>
        <p>لا تتخذ قراراً متسرعاً بسبب ضغط الأهل أو المجتمع.</p>
        
        <h4>إخفاء عيوبك</h4>
        <p>الصراحة مهمة. أي شيء تخفيه سيظهر لاحقاً وقد يسبب مشاكل.</p>
      `
    }
  ];

  const [selectedArticle, setSelectedArticle] = useState(null);

  return (
    <div className="page-container islamic-pattern">
      <div className="card" style={{ maxWidth: '800px', width: '100%', padding: '24px' }}>
        
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '24px' }}>
          <h1 style={{ 
            fontSize: '28px', 
            color: '#00897B', 
            marginBottom: '8px',
            fontFamily: "'Tajawal', sans-serif",
            fontWeight: '800'
          }}>
            📚 قصص ونصائح
          </h1>
          <p style={{ color: 'var(--text-light)', fontSize: '14px' }}>
            قصص نجاح ملهمة ونصائح للباحثين عن شريك الحياة
          </p>
        </div>

        {/* Tabs */}
        <div style={{ 
          display: 'flex', 
          gap: '8px', 
          marginBottom: '24px',
          justifyContent: 'center'
        }}>
          <button
            onClick={() => setActiveTab('stories')}
            style={{
              padding: '12px 24px',
              borderRadius: '25px',
              border: 'none',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '600',
              background: activeTab === 'stories' 
                ? 'linear-gradient(135deg, #00897B, #00B4A2)' 
                : 'var(--light-bg)',
              color: activeTab === 'stories' ? '#fff' : 'var(--text-dark)'
            }}
          >
            💑 قصص النجاح
          </button>
          <button
            onClick={() => setActiveTab('articles')}
            style={{
              padding: '12px 24px',
              borderRadius: '25px',
              border: 'none',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '600',
              background: activeTab === 'articles' 
                ? 'linear-gradient(135deg, #00897B, #00B4A2)' 
                : 'var(--light-bg)',
              color: activeTab === 'articles' ? '#fff' : 'var(--text-dark)'
            }}
          >
            📖 نصائح ومقالات
          </button>
        </div>

        {/* Success Stories Tab */}
        {activeTab === 'stories' && (
          <div>
            <div style={{ 
              background: 'linear-gradient(135deg, rgba(0, 137, 123, 0.1), rgba(0, 180, 162, 0.05))',
              padding: '16px',
              borderRadius: '12px',
              marginBottom: '20px',
              textAlign: 'center'
            }}>
              <p style={{ color: '#00897B', fontSize: '14px', margin: 0 }}>
                ✨ قصص حقيقية لأزواج التقوا عبر وِداد
              </p>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              {successStories.map(story => (
                <div 
                  key={story.id}
                  style={{
                    background: '#fff',
                    borderRadius: '16px',
                    padding: '20px',
                    boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
                    border: '1px solid rgba(0, 137, 123, 0.1)'
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
                    <span style={{ fontSize: '36px' }}>{story.image}</span>
                    <div>
                      <h3 style={{ margin: 0, color: '#00897B', fontSize: '18px' }}>{story.title}</h3>
                      <p style={{ margin: '4px 0 0', color: 'var(--text-light)', fontSize: '12px' }}>
                        📍 {story.location} • 📅 {story.date}
                      </p>
                    </div>
                  </div>
                  <p style={{ 
                    color: 'var(--text-dark)', 
                    lineHeight: '1.8', 
                    fontSize: '14px',
                    margin: 0,
                    fontFamily: "'Noto Naskh Arabic', serif"
                  }}>
                    "{story.story}"
                  </p>
                </div>
              ))}
            </div>

            <div style={{ 
              textAlign: 'center', 
              marginTop: '24px',
              padding: '20px',
              background: 'var(--light-bg)',
              borderRadius: '12px'
            }}>
              <p style={{ color: 'var(--text-dark)', marginBottom: '12px', fontSize: '14px' }}>
                هل لديك قصة نجاح تريد مشاركتها؟
              </p>
              <button 
                onClick={() => window.open('mailto:help.wedad@gmail.com', '_blank')}
                style={{
                  padding: '10px 24px',
                  background: 'linear-gradient(135deg, #00897B, #00B4A2)',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
              >
                شاركنا قصتك 💌
              </button>
            </div>
          </div>
        )}

        {/* Articles Tab */}
        {activeTab === 'articles' && !selectedArticle && (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '16px' }}>
            {articles.map(article => (
              <div 
                key={article.id}
                onClick={() => setSelectedArticle(article)}
                style={{
                  background: '#fff',
                  borderRadius: '16px',
                  padding: '20px',
                  boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
                  border: '1px solid rgba(0, 137, 123, 0.1)',
                  cursor: 'pointer',
                  transition: 'transform 0.2s, box-shadow 0.2s'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,137,123,0.15)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 12px rgba(0,0,0,0.06)';
                }}
              >
                <span style={{ fontSize: '32px', display: 'block', marginBottom: '12px' }}>{article.icon}</span>
                <span style={{ 
                  background: 'rgba(0, 137, 123, 0.1)', 
                  color: '#00897B',
                  padding: '4px 12px',
                  borderRadius: '12px',
                  fontSize: '11px',
                  fontWeight: '600'
                }}>
                  {article.category}
                </span>
                <h3 style={{ 
                  margin: '12px 0 0', 
                  color: 'var(--text-dark)', 
                  fontSize: '16px',
                  fontWeight: '600'
                }}>
                  {article.title}
                </h3>
              </div>
            ))}
          </div>
        )}

        {/* Single Article View */}
        {activeTab === 'articles' && selectedArticle && (
          <div>
            <button
              onClick={() => setSelectedArticle(null)}
              style={{
                background: 'none',
                border: 'none',
                color: '#00897B',
                cursor: 'pointer',
                fontSize: '14px',
                marginBottom: '16px',
                display: 'flex',
                alignItems: 'center',
                gap: '4px'
              }}
            >
              → العودة للمقالات
            </button>
            
            <div style={{
              background: '#fff',
              borderRadius: '16px',
              padding: '24px',
              boxShadow: '0 2px 12px rgba(0,0,0,0.06)'
            }}>
              <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                <span style={{ fontSize: '48px' }}>{selectedArticle.icon}</span>
                <h2 style={{ color: '#00897B', margin: '12px 0 8px', fontSize: '22px' }}>
                  {selectedArticle.title}
                </h2>
                <span style={{ 
                  background: 'rgba(0, 137, 123, 0.1)', 
                  color: '#00897B',
                  padding: '4px 16px',
                  borderRadius: '12px',
                  fontSize: '12px'
                }}>
                  {selectedArticle.category}
                </span>
              </div>
              
              <div 
                style={{ 
                  color: 'var(--text-dark)', 
                  lineHeight: '2',
                  fontSize: '15px',
                  fontFamily: "'Noto Naskh Arabic', serif"
                }}
                dangerouslySetInnerHTML={{ __html: selectedArticle.content }}
              />
            </div>
          </div>
        )}

        {/* Back Button */}
        <div style={{ textAlign: 'center', marginTop: '24px' }}>
          <button
            onClick={() => navigate('/dashboard')}
            style={{
              padding: '12px 32px',
              background: 'var(--light-bg)',
              color: 'var(--text-dark)',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '14px'
            }}
          >
            ← العودة للرئيسية
          </button>
        </div>
      </div>
    </div>
  );
}

export default SuccessStoriesPage;
